import React from 'react';
import { scaleColorTraffic as color } from 'js/utils/color';

import styles from '../DetailsPane.module.scss';

const timeFormatter = new Intl.DateTimeFormat(undefined, {
  month: 'long',
  day: 'numeric',
  year: 'numeric',
});

export const QuestionDetailPane = ({
  summaryData,
  filter: {
    criteria: { questionSetKey, questionKey },
  },
}) => {
  const lastAskedAssessment = Object.values(summaryData?.assessments ?? {})
    .sort((a, b) => b.inserted_at - a.inserted_at)
    .find((a) => !!a.questionSets?.[questionSetKey]?.questions?.[questionKey]);
  const questionSet = summaryData?.questionSets?.[questionSetKey];
  const question = questionSet?.questions?.[questionKey];

  if (!question) {
    return null;
  }

  const answers = question.answers ?? [];
  const lastAsked = lastAskedAssessment?.inserted_at
    ? timeFormatter.format(lastAskedAssessment.inserted_at)
    : null;

  return (
    <div>
      <label>Question</label>
      <p>{question.text}</p>
      {lastAsked ? (
        <>
          <label>Last asked</label>
          <div className={`${styles['panel-section']} text-sm`}>
            {lastAsked}
          </div>
        </>
      ) : null}
      <label>Answers</label>
      <section className={`${styles['answer-grid']} text-sm`}>
        {answers.map((answer) => (
          <React.Fragment
            key={`${answer.value}-${answer.ordinal}-${answer.text}`}
          >
            <div className={styles.score}>
              <div
                className={styles['score-value']}
                style={{
                  borderColor: color(answer.normalizedScore),
                }}
              />
            </div>
            <div>{answer.text}</div>
          </React.Fragment>
        ))}
      </section>
    </div>
  );
};

export default QuestionDetailPane;
